import script from "./giveUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./giveUserForm.vue?vue&type=script&setup=true&lang=js"

import "./giveUserForm.vue?vue&type=style&index=0&id=e536c468&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e536c468"]])

export default __exports__